import axios from "axios";

const Services = axios.create({
    baseURL: '/'
});


//If this parameter is sent false in axios requests, no warning messages will be received. default: true{ handlerEnabled: false }
const isHandlerEnabled = (config = {}) => {
    return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
        false : true
}

const requestHandler = (request) => {
    if (isHandlerEnabled(request)) {
        console.log(`Sending request to: ${request.url}`)
    }
    return request
}

const errorHandler = (error) => {
    if (isHandlerEnabled(error.config)) {
        // Error
    }
    return Promise.reject({ ...error })
}

const successHandler = (response) => {
    if (isHandlerEnabled(response.config)) {
        // Success
    }
    return response
}


Services.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
)

export default Services;